import React from 'react';
import { ClipboardCheckIcon, FileTextIcon, UsersIcon, ScaleIcon } from 'lucide-react';
export function ComingSoon() {
  const upcomingServices = [{
    title: 'Servicios de Auditoría',
    description: 'Auditorías financieras, operativas y de cumplimiento para garantizar la transparencia de tu empresa.',
    icon: ClipboardCheckIcon
  }, {
    title: 'Diferentes Tipos de Trámites',
    description: 'Gestión de trámites ante SAT, IGSS, Ministerio de Trabajo y otras entidades gubernamentales.',
    icon: FileTextIcon
  }, {
    title: 'Colaboraciones con Oficinas Contables',
    description: 'Red de colaboración con otras oficinas contables para servicios especializados.',
    icon: UsersIcon
  }, {
    title: 'Colaboraciones con Firmas de Abogados',
    description: 'Alianzas estratégicas con oficinas jurídicas para servicios legales complementarios.',
    icon: ScaleIcon
  }];
  return <section id="proximamente" className="py-20 bg-gradient-to-br from-purple-900 via-purple-800 to-purple-900 text-white" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="text-center mb-16" data-id="element-74">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-75">Próximamente</h2>
          <p className="text-xl text-purple-200" data-id="element-76">
            Expandiendo nuestros servicios para servirte mejor
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-77">
          {upcomingServices.map((service, index) => <div key={index} className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2 border border-white/20" data-id="element-78">
              <service.icon className="w-12 h-12 text-purple-300 mb-4 group-hover:scale-110 transition-transform" data-id="element-79" />
              <h3 className="text-2xl font-bold mb-3" data-id="element-80">{service.title}</h3>
              <p className="text-purple-100" data-id="element-81">{service.description}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-82">
          <div className="inline-block bg-white/10 backdrop-blur-sm rounded-2xl px-8 py-6 border border-white/20" data-id="element-83">
            <p className="text-lg mb-4" data-id="element-84">
              ¿Interesado en alguno de estos servicios?
            </p>
            <a href="https://wa.me/50236387717" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-3 bg-white text-purple-900 font-bold rounded-lg hover:bg-purple-100 transition-all" data-id="element-85">
              Contáctanos
            </a>
          </div>
        </div>
      </div>
    </section>;
}